import { useEffect, useRef } from "preact/hooks"

const easeOutQuad = (t) => t * (2 - t)
const raf = window.requestAnimationFrame

function formatNumber(num) {
  return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
}

function countTo(targetElement, from, to, ms) {
  let start
  const delta = to - from
  const next = (timestamp) => {
    if (start === undefined) {
      start = timestamp
    }
    const progress = (timestamp - start) / ms

    const current = Math.ceil(from + easeOutQuad(progress) * delta)
    targetElement.innerHTML = formatNumber(current)

    if (progress < 1) {
      raf(next)
    } else {
      targetElement.innerHTML = formatNumber(to)
    }
  }
  raf(next)
}

function FactNumber({ current }) {
  const ref = useRef()
  const number = useRef()

  useEffect(() => {
    number.current = 0
    ref.current.innerHTML = "0"
  }, [])

  useEffect(() => {
    const callback = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          countTo(ref.current, number.current, current, 1000)
          number.current = current
          io.disconnect()
        }
      })
    }
    const io = new IntersectionObserver(callback)
    io.observe(ref.current)
  }, [current])

  return <div class="fact__number" ref={ref} />
}

export function FactsAndFigures({ plugin }) {
  return (
    <div class="facts-container">
      <div class="facts">
        <div class="fact">
          <div class="fact__icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="79.145"
              height="74.524"
              viewBox="0 0 79.145 74.524"
            >
              <g
                id="Gruppe_1880"
                data-name="Gruppe 1880"
                transform="translate(-7.58 -10.06)"
              >
                <path
                  id="Pfad_966"
                  data-name="Pfad 966"
                  d="M72.382,10.81H64.929v5.161H50.879V10.81H43.426v5.161H29.376V10.81H21.923v5.161H8.33V83.834H85.975V15.971H72.382Zm6.14,65.571H15.783V42.151H78.522Zm0-52.965V34.689H15.783V23.425h6.14v5.161h7.453V23.425h14.05v5.161h7.453V23.425h14.05v5.161h7.453V23.425Z"
                  fill="none"
                  stroke="#ef6358"
                  stroke-width="1.5"
                />
                <path
                  id="Pfad_967"
                  data-name="Pfad 967"
                  d="M59.877,51.223,55.769,46.93,40.95,61.118,33.8,53.964l-4.2,4.2L40.861,69.43Z"
                  transform="translate(2.395 0.392)"
                  fill="none"
                  stroke="#ef6358"
                  stroke-width="1.5"
                />
              </g>
            </svg>
          </div>
          <FactNumber current={plugin.events} key="events" />
          <div class="fact__text"> Events</div>
        </div>

        <div class="fact">
          <div class="fact__icon">
            <svg
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              width="75.768"
              height="75.768"
              viewBox="0 0 85 85"
            >
              <path
                d="M42.58 83.92A16.86 16.86 0 0 1 25.7 67.04a7.72 7.72 0 0 0-7.72-7.71A16.84 16.84 0 0 1 2.3 48.94a16.89 16.89 0 0 1 9.23-22.14 16.92 16.92 0 0 1 6.37-1.21h.13a7.72 7.72 0 0 0 7.67-7.7A16.89 16.89 0 0 1 45.87 1.32a16.89 16.89 0 0 1-3.29 33.45 7.69 7.69 0 0 0-7.11 4.76 7.711 7.711 0 0 0 7.12 10.65 7.7 7.7 0 0 0 7.7-7.7 16.84 16.84 0 0 1 10.42-15.6 16.67 16.67 0 0 1 6.46-1.29 17.31 17.31 0 0 1 3.29.32 16.89 16.89 0 0 1-3.29 33.45 7.72 7.72 0 0 0-7.7 7.71 16.858 16.858 0 0 1-16.89 16.88v-.03Z"
                stroke="#ef6358"
                stroke-width="1.5"
                stroke-linejoin="round"
              />
              <path
                d="M17.98 52.74a14.31 14.31 0 0 1 10.12 4.19 14.001 14.001 0 0 1 3.1 4.64 14.24 14.24 0 0 1 1.09 5.47 10.25 10.25 0 0 0 .78 3.94 10.41 10.41 0 0 0 2.23 3.34 10.28 10.28 0 0 0 7.28 3 10.28 10.28 0 0 0 7.28-3 10.228 10.228 0 0 0 3-7.28c0-1.877.37-3.736 1.09-5.47a14.001 14.001 0 0 1 3.1-4.64 14.27 14.27 0 0 1 10.1-4.19 10.28 10.28 0 0 0 5.72-1.73 10.39 10.39 0 0 0 3.8-4.62 10.3 10.3 0 1 0-19.81-3.94 14.3 14.3 0 1 1-14.3-14.3 10.3 10.3 0 1 0-10.29-10.29 14.31 14.31 0 0 1-4.19 10.11 14.127 14.127 0 0 1-4.64 3.09 14 14 0 0 1-5.56 1.09c-1.333 0-2.654.258-3.89.76a10.142 10.142 0 0 0-3.37 2.22 10.362 10.362 0 0 0-2.26 3.36 10.32 10.32 0 0 0 0 7.92 10.322 10.322 0 0 0 2.26 3.35c.964.958 2.11 1.713 3.37 2.22 1.266.517 2.623.776 3.99.76Z"
                stroke="#ef6358"
                stroke-width="1.5"
                stroke-linejoin="round"
              />
            </svg>
          </div>
          <FactNumber current={plugin.participants_at_events} />
          <div class="fact__text"> Participants at Swissnex events</div>
        </div>

        <div class="fact">
          <div class="fact__icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="78.127"
              height="78.126"
              viewBox="0 0 78.127 78.126"
            >
              <g
                id="Gruppe_1881"
                data-name="Gruppe 1881"
                transform="translate(0.75 0.75)"
              >
                <path
                  id="Pfad_968"
                  data-name="Pfad 968"
                  d="M38.313,0A38.313,38.313,0,1,0,76.627,38.314,38.357,38.357,0,0,0,38.313,0Zm3.211,19.993V6.637c3.076,1.766,6.389,7.2,8.419,13.356Zm9.983,5.383a84.383,84.383,0,0,1,1.25,10H41.524v-10ZM35.372,6.637V19.993H26.684C28.714,13.841,31.527,8.4,35.372,6.637Zm0,18.739v10h-11.5a84.383,84.383,0,0,1,1.25-10Zm-17.438,10H6.067a36.138,36.138,0,0,1,2.519-10H19.009A95.033,95.033,0,0,0,17.934,35.372Zm0,6.152a64.958,64.958,0,0,0,1.075,10H8.585a30.365,30.365,0,0,1-2.518-10Zm5.936,0h11.5v10H25.12A68.409,68.409,0,0,1,23.869,41.524Zm11.5,16.148V69.99c-3.845-1.766-6.658-6.166-8.689-12.318ZM41.524,69.99V57.672h8.419C47.913,63.823,44.6,68.224,41.524,69.99Zm0-18.47v-10H52.757a68.409,68.409,0,0,1-1.25,10Zm17.169-10H70.56a30.384,30.384,0,0,1-2.518,10H57.618A64.958,64.958,0,0,0,58.693,41.524Zm0-6.152a95.015,95.015,0,0,0-1.075-10H68.041a36.137,36.137,0,0,1,2.519,10Zm5.992-15.379h-8.47A35.92,35.92,0,0,0,51.43,9.157,33.265,33.265,0,0,1,64.685,19.993ZM25.2,9.157a35.93,35.93,0,0,0-4.785,10.836h-8.47A33.266,33.266,0,0,1,25.2,9.157ZM11.94,57.672h8.471A47.277,47.277,0,0,0,25.2,68.509,33.268,33.268,0,0,1,11.94,57.672ZM51.431,68.508a47.271,47.271,0,0,0,4.784-10.836h8.47A33.264,33.264,0,0,1,51.431,68.508Z"
                  transform="translate(0 0)"
                  fill="none"
                  stroke="#ef6358"
                  stroke-width="1.5"
                />
              </g>
            </svg>
          </div>
          <FactNumber current={plugin.participating_startups} />
          <div class="fact__text">
            {" "}
            Participating start-ups in internationalization camps{" "}
          </div>
        </div>

        <div class="fact">
          <div class="fact__icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="91.681"
              height="91.68"
              viewBox="0 0 91.681 91.68"
            >
              <g
                id="Gruppe_1883"
                data-name="Gruppe 1883"
                transform="translate(0.341 0.34)"
              >
                <path
                  id="Pfad_971"
                  data-name="Pfad 971"
                  d="M90.584,49.386c-.143-6.642-5.26-12-11.535-12s-11.39,5.359-11.534,12c0,.07-.006.138-.006.207,0,5.823-1.948,10.01-5.955,12.806A19.482,19.482,0,0,1,55.935,65a12.7,12.7,0,0,0,.676-4.1c0-6.582-4.989-11.945-11.154-12.037l-.121,0H3.5a3.2,3.2,0,0,0-3.1,3.3v3.162A44.037,44.037,0,0,0,4,73.225,38.2,38.2,0,0,0,13.837,86.61C21.92,93.692,33.165,97.591,45.5,97.591A43.466,43.466,0,0,0,77.383,83.533a49.274,49.274,0,0,0,13.2-33.793c0-.023,0-.045,0-.069V49.6C90.59,49.525,90.586,49.456,90.584,49.386ZM45.5,91C26.174,91,6.676,80.006,6.6,55.453H45.3a5.46,5.46,0,0,1,0,10.9H24.88a3.3,3.3,0,0,0,0,6.592H45.911c.044,0,.089,0,.133,0,7.867-.074,14.225-1.763,18.905-5.027,5.69-3.969,8.713-10.25,8.752-18.168,0-.024,0-.05,0-.075A5.357,5.357,0,1,1,84.4,49.644C84.371,72.451,66.932,91,45.5,91Z"
                  transform="translate(0 -7.001)"
                  fill="none"
                  stroke="#ef6358"
                  stroke-width="1.5"
                />
                <path
                  id="Pfad_972"
                  data-name="Pfad 972"
                  d="M27.918,39.424a2.9,2.9,0,0,0,2.977-2.808c0-7.307,6.3-13.251,14.046-13.251S58.987,29.31,58.987,36.616V44.84a2.982,2.982,0,0,0,5.953,0V36.616A18.842,18.842,0,0,0,53.6,19.609a10.976,10.976,0,0,0,3.361-7.858C56.961,5.5,51.568.41,44.94.41S32.918,5.5,32.918,11.751a10.976,10.976,0,0,0,3.362,7.858A18.842,18.842,0,0,0,24.94,36.616,2.9,2.9,0,0,0,27.918,39.424Zm17.023-33.4a5.91,5.91,0,0,1,6.068,5.724,6.078,6.078,0,0,1-12.136,0A5.909,5.909,0,0,1,44.941,6.026Z"
                  transform="translate(-4.133)"
                  fill="none"
                  stroke="#ef6358"
                  stroke-width="1.5"
                />
              </g>
            </svg>
          </div>
          <FactNumber current={plugin.supported_startups} />
          <div class="fact__text"> Supported start-ups through services </div>
        </div>

        <div class="fact">
          <div class="fact__icon">
            <svg
              width="85"
              height="85"
              viewBox="0 0 85 85"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M24.7092 83.26V59.5H0.949219V24.7099H24.7092V0.949951H59.4992V24.7099H83.2592V59.5H59.4992V83.26H24.7092Z"
                stroke="#ef6358"
                stroke-width="1.5"
              />
              <path
                d="M76.67 52.9H52.9V76.67H31.3V52.9H7.5V31.3H31.3V7.54004H52.9V31.3H76.67V52.9Z"
                stroke="#ef6358"
                stroke-width="1.5"
              />
            </svg>
          </div>
          <FactNumber current={plugin.swiss_partners} />
          <div class="fact__text"> Swiss partners</div>
        </div>

        <div class="fact">
          <div class="fact__icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="127.674"
              height="68.022"
              viewBox="0 0 127.674 68.022"
            >
              <g
                id="Gruppe_1889"
                data-name="Gruppe 1889"
                transform="translate(-916.999 -2448.09)"
              >
                <path
                  id="Pfad_980"
                  data-name="Pfad 980"
                  d="M30.017,66.931a4.937,4.937,0,0,0,5.075-4.788c0-12.459,10.744-22.594,23.949-22.594s23.95,10.136,23.95,22.594h0a4.938,4.938,0,0,0,5.075,4.79,5.27,5.27,0,0,0,4.773-3.158,3.874,3.874,0,0,0,.3-1.631h0c0-12.753-7.9-23.795-19.336-29a18.715,18.715,0,0,0,5.731-13.4c0-10.663-9.2-19.337-20.5-19.337s-20.5,8.674-20.5,19.337a18.714,18.714,0,0,0,5.733,13.4c-11.43,5.2-19.336,16.245-19.336,29A4.938,4.938,0,0,0,30.017,66.931ZM59.043,9.986c5.706,0,10.346,4.379,10.346,9.759s-4.64,9.761-10.346,9.761S48.7,25.127,48.7,19.745,53.337,9.986,59.043,9.986Z"
                  transform="translate(892.809 2448.43)"
                  fill="none"
                  stroke="#ef6358"
                  stroke-width="1.5"
                />
                <path
                  id="Pfad_981"
                  data-name="Pfad 981"
                  d="M30.017,66.931a4.937,4.937,0,0,0,5.075-4.788c0-12.459,10.744-22.594,23.949-22.594s23.95,10.136,23.95,22.594h0a4.938,4.938,0,0,0,5.075,4.79,5.27,5.27,0,0,0,4.773-3.158,3.874,3.874,0,0,0,.3-1.631h0c0-12.753-7.9-23.795-19.336-29a18.715,18.715,0,0,0,5.731-13.4c0-10.663-9.2-19.337-20.5-19.337s-20.5,8.674-20.5,19.337a18.714,18.714,0,0,0,5.733,13.4c-11.43,5.2-19.336,16.245-19.336,29A4.938,4.938,0,0,0,30.017,66.931ZM59.043,9.986c5.706,0,10.346,4.379,10.346,9.759s-4.64,9.761-10.346,9.761S48.7,25.127,48.7,19.745,53.337,9.986,59.043,9.986Z"
                  transform="translate(950.781 2448.43)"
                  fill="none"
                  stroke="#ef6358"
                  stroke-width="1.5"
                />
              </g>
            </svg>
          </div>
          <FactNumber current={plugin.employees} />
          <div class="fact__text"> Employees</div>
        </div>
      </div>
    </div>
  )
}

export function WebsiteAndFollowerFacts({ plugin }) {
  const reportYear = parseInt(document.querySelector('[data-report]')?.dataset.report, 10)
  const showLegacySocial = reportYear <= 2024
  return (
    <div class="facts-container">
      <div class="facts">
        <div class="fact">
          <div class="fact__icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="88.754"
              height="51"
              viewBox="0 0 88.754 51"
            >
              <g
                id="Gruppe_1867"
                data-name="Gruppe 1867"
                transform="translate(14.943 13.067)"
              >
                <path
                  id="Pfad_884"
                  data-name="Pfad 884"
                  d="M29.432,37.433c-23.631,0-42.246-22.063-43.028-23a3.124,3.124,0,0,1,0-3.994c.782-.941,19.4-23,43.028-23s42.247,22.062,43.029,23a3.117,3.117,0,0,1,0,3.994C71.679,15.37,53.064,37.433,29.432,37.433Zm-36.393-25c4.993,5.2,19.609,18.75,36.393,18.75s31.4-13.547,36.394-18.75C60.832,7.23,46.22-6.317,29.432-6.317S-1.971,7.23-6.961,12.433ZM29.432,28.058A15.625,15.625,0,1,1,45.057,12.433,15.643,15.643,0,0,1,29.432,28.058Zm0-25a9.375,9.375,0,1,0,9.375,9.375A9.387,9.387,0,0,0,29.432,3.058Z"
                  fill="none"
                  stroke="#ff1300"
                  stroke-width="1"
                />
              </g>
            </svg>
          </div>
          <FactNumber current={plugin.page_views} />
          <div class="fact__text"> # of page views</div>
        </div>

        <div class="fact">
          <div class="fact__icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="58.041"
              height="69.284"
              viewBox="0 0 58.041 69.284"
            >
              <g
                id="Gruppe_1869"
                data-name="Gruppe 1869"
                transform="translate(-29.458 -25.5)"
              >
                <path
                  id="Pfad_885"
                  data-name="Pfad 885"
                  d="M85.975,41.041a2.842,2.842,0,0,0-4.005,0l-4.1,4.09A28.3,28.3,0,0,0,61.247,37.5V31.681h5.681a2.841,2.841,0,0,0,0-5.681H49.885a2.841,2.841,0,1,0,0,5.681h5.681V37.5a28.3,28.3,0,0,0-16.618,7.627l-4.1-4.09a2.841,2.841,0,0,0-4.005,4.005l4.375,4.389a28.406,28.406,0,1,0,46.387,0l4.375-4.389A2.842,2.842,0,0,0,85.975,41.041ZM58.407,88.494A22.725,22.725,0,1,1,81.132,65.769,22.724,22.724,0,0,1,58.407,88.494Z"
                  transform="translate(0 0)"
                  fill="none"
                  stroke="#ff1300"
                  stroke-width="1"
                />
                <path
                  id="Pfad_886"
                  data-name="Pfad 886"
                  d="M62.2,56.2H53.681V44.841a2.841,2.841,0,1,0-5.681,0v14.2a2.84,2.84,0,0,0,2.841,2.841H62.2a2.841,2.841,0,1,0,0-5.681Z"
                  transform="translate(7.566 6.725)"
                  fill="none"
                  stroke="#ff1300"
                  stroke-width="1"
                />
              </g>
            </svg>
          </div>
          <FactNumber current={plugin.page_scrolls} />
          <div class="fact__text"> # of scroll events</div>
        </div>

        <div class="fact">
          <div class="fact__icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="54.25"
              height="59.723"
              viewBox="0 0 54.25 59.723"
            >
              <path
                id="Icon_simple-email"
                data-name="Icon simple-email"
                d="M54.884,27.1a30.285,30.285,0,0,1-.976,6.568,19.008,19.008,0,0,1-2.554,5.768,13.477,13.477,0,0,1-4.33,4.1A12.22,12.22,0,0,1,40.7,45.1a9.166,9.166,0,0,1-4.572-1.119,7.83,7.83,0,0,1-3.09-3.167,9.793,9.793,0,0,1-8.286,4.161,8.425,8.425,0,0,1-7.233-3.89,12.733,12.733,0,0,1-1.8-4.506,19.433,19.433,0,0,1-.235-5.879,27.307,27.307,0,0,1,1.791-7.2,19.569,19.569,0,0,1,3.31-5.515,14,14,0,0,1,4.55-3.515,12.7,12.7,0,0,1,5.534-1.229,17.206,17.206,0,0,1,3.31.283,13.548,13.548,0,0,1,2.569.771,13.89,13.89,0,0,1,2.128,1.123c.649.418,1.3.851,1.952,1.292L39.025,35.2a6.147,6.147,0,0,0,.048,2.165,3.029,3.029,0,0,0,.661,1.336,2.378,2.378,0,0,0,1.071.7,3.978,3.978,0,0,0,3.765-.741,8.024,8.024,0,0,0,2.018-2.569,16.543,16.543,0,0,0,1.358-3.86,26.487,26.487,0,0,0,.594-4.807,30.721,30.721,0,0,0-.756-8.983,17.856,17.856,0,0,0-3.325-6.95A15.437,15.437,0,0,0,38.5,7.012a21.629,21.629,0,0,0-8.682-1.589,19.17,19.17,0,0,0-8.587,1.871,19.7,19.7,0,0,0-6.524,5.189,24.9,24.9,0,0,0-4.271,7.8,35.173,35.173,0,0,0-1.8,9.724,32.336,32.336,0,0,0,.917,9.922,17.921,17.921,0,0,0,3.625,7.111,15.129,15.129,0,0,0,6.143,4.271A23.562,23.562,0,0,0,27.8,52.734a29.033,29.033,0,0,0,5.563-.6c.917-.183,1.787-.4,2.616-.646a19.691,19.691,0,0,0,2.253-.807L39.4,55.916a12.913,12.913,0,0,1-2.521,1.248,24.266,24.266,0,0,1-2.98.862,29.074,29.074,0,0,1-6.223.7A32.637,32.637,0,0,1,16.325,56.9a20.882,20.882,0,0,1-8.271-5.438,22.839,22.839,0,0,1-4.965-8.979A38.3,38.3,0,0,1,1.7,30.013,38.016,38.016,0,0,1,4.088,18.05a29.606,29.606,0,0,1,5.746-9.5A26.185,26.185,0,0,1,18.6,2.275,27.446,27.446,0,0,1,29.954,0a28.655,28.655,0,0,1,11,1.971A21.4,21.4,0,0,1,48.9,7.511a22.739,22.739,0,0,1,4.712,8.561A32.734,32.734,0,0,1,54.884,27.1ZM23.371,30.7a12.483,12.483,0,0,0,.646,6.19,3.319,3.319,0,0,0,3.192,2.092,3.526,3.526,0,0,0,1.094-.2,3.9,3.9,0,0,0,1.259-.756,6.717,6.717,0,0,0,1.277-1.541,11.828,11.828,0,0,0,1.174-2.605l1.255-14.37a7.5,7.5,0,0,0-1.952-.257,6.75,6.75,0,0,0-3.247.745,6.429,6.429,0,0,0-2.3,2.187,12.843,12.843,0,0,0-1.527,3.6,30.505,30.505,0,0,0-.866,4.917Z"
                transform="translate(-1.17 0.5)"
                fill="none"
                stroke="#ec4033"
                stroke-linejoin="round"
                stroke-miterlimit="1.414"
                stroke-width="1"
              />
            </svg>
          </div>
          <FactNumber current={plugin.newsletter_subscribers} />
          <div class="fact__text"> Swissnex newsletter subscribers </div>
        </div>

        {showLegacySocial && <div class="fact">
          <div class="fact__icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="41.581"
              height="75.57"
              viewBox="0 0 41.581 75.57"
            >
              <g
                id="Icon_zocial-facebook"
                data-name="Icon zocial-facebook"
                transform="translate(-12.257 1)"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path
                  d="M13.257,39.507V25.458H24.589V18.393A18.489,18.489,0,0,1,29.553,5.371,15.791,15.791,0,0,1,41.582,0H52.838V14.052H41.582A2.479,2.479,0,0,0,39.6,15.266a4.929,4.929,0,0,0-.883,2.98v7.21H52.838V39.5H38.712V73.57H24.587V39.507Z"
                  stroke="none"
                />
              </g>
            </svg>
          </div>
          <FactNumber current={plugin.facebook_followers} />
          <div class="fact__text"> # of Facebook followers </div>
        </div>}

        <a class="fact" href="https://www.linkedin.com/company/swissnex/">
          <div class="fact__icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="59.227"
              height="56.686"
              viewBox="0 0 59.227 56.686"
            >
              <g
                id="Icon_zocial-linkedin"
                data-name="Icon zocial-linkedin"
                transform="translate(1.18 0.784)"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path
                  d="M-.18,6.568A5.948,5.948,0,0,1,1.753,2.011,7.093,7.093,0,0,1,6.78.216,6.881,6.881,0,0,1,11.7,1.984a6.23,6.23,0,0,1,1.933,4.75,5.817,5.817,0,0,1-1.878,4.419A7.105,7.105,0,0,1,6.67,12.976H6.614A6.76,6.76,0,0,1,1.7,11.153,6.122,6.122,0,0,1-.18,6.568ZM.538,54.9V18H12.8V54.9H.538Zm19.057,0H31.858V34.3a7.952,7.952,0,0,1,.442-2.983,8.011,8.011,0,0,1,2.348-3.176,6,6,0,0,1,3.95-1.3q6.187,0,6.187,8.341V54.9H57.047V33.745q0-8.175-3.867-12.4a13.19,13.19,0,0,0-10.219-4.226,12.535,12.535,0,0,0-11.1,6.131v.11H31.8l.055-.11V18H19.6q.11,1.768.11,10.992T19.6,54.9Z"
                  stroke="none"
                />
              </g>
            </svg>
          </div>
          <FactNumber current={plugin.linkedin_followers} />
          <div class="fact__text"> # of LinkedIn followers </div>
        </a>

        
        {showLegacySocial && <a class="fact" href="https://twitter.com/swissnexNetwork">
          <div class="fact__icon">
            <svg
              fill="currentColor"
              class="bi bi-twitter-x"
              viewBox="0 0 16 16"
              version="1.1"
              id="svg1"
            >
              <defs id="defs1" />
              <path
                d="m 11.755247,2.0812105 h 2.003409 L 9.3828333,7.0954457 14.530956,13.918789 H 10.500464 L 7.3435042,9.7797188 3.7310017,13.918789 H 1.7267771 L 6.4071109,8.5551416 1.4687995,2.0812105 h 4.133356 L 8.4554202,5.8635211 11.756064,2.0812105 Z"
                id="path1"
                style="stroke:currentColor;stroke-opacity:1;fill:none;stroke-width:0.2;stroke-dasharray:none"
              />
            </svg>
          </div>
          <FactNumber current={plugin.twitter_followers} />
          <div class="fact__text"> # of X followers </div>
        </a>}
      </div>
    </div>
  )
}
